/* global $, API_KEY, HELPFUL_STACKS, firebase, SENTRY_DSN, VERSION */

import { setConfig, getConfig } from './config'
import { fbGetConsent, fbSetConsent } from './firebase'
import * as Sentry from '@sentry/browser'

// import 'slick-carousel' // Lazily loaded in documenReady method
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import 'jquery-lazy'

import { hasFeature, onUpdate } from './feature-flags'
import * as Metrics from './metrics'

import 'jquery-ui/tooltip'
import 'jquery-ui-css/core.css'
import 'jquery-ui-css/tooltip.css'
import 'jquery-ui-css/theme.css'

import './jquery.lc_switch.js'
import '../styles/jquery.lc_switch.css'

import '../styles/welcomeWizard.css'

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    release: VERSION
  })
}

var Promise = window.TrelloPowerUp.Promise

const t = window.TrelloPowerUp.iframe({
  appKey: API_KEY,
  appName: 'Processes For Trello',
  helpfulStacks: HELPFUL_STACKS
})

    Sentry.getCurrentScope().setUser({ id: t.getContext().member })

var skipSettings = false
var settingsDisabled = false
var localConsent

$(function () {
  Metrics.init(t)
  return import('slick-carousel').then(() => {
    $('#loader').hide()
    $('#content').show()
    $('img.lazy').Lazy({
      afterLoad: function (el) {
        el.siblings('.spinner').hide();
        el.show();
      }
    })

    $('.icon-lock').tooltip()
    $('.js-switch-yes-no').lc_switch('YES', 'NO')

    const sldr = $('#slider')
    sldr.slick({
      infinite: false,
      dots: true,
      arrows: false,
      adaptiveHeight: true,
      draggable: false
    })

    $('#list-selector').on('change', evt => setConfig(t, { targetId: evt.target.value }))
    $('#open-list-selector').on('change', evt => setConfig(t, { openListId: evt.target.value }))
    $('#started-list-selector').on('change', evt => setConfig(t, { startedListId: evt.target.value }))
    $('#done-list-selector').on('change', evt => setConfig(t, { doneListId: evt.target.value }))
    $('#position-selector').on('change', evt => setConfig(t, { position: evt.target.value }))
    $('#board-selector').on('change', evt => setConfig(t, { templateBoard: evt.target.value }))
    // $('#delete-chkbx').on('change', evt => setConfig(t, { deleteChildren: evt.target.checked }))

    // $('body').delegate('#remove-cards', 'lcs-statuschange', () => {
    //   const deleteChildren = $('#remove-cards').is(':checked')
    //   setConfig(t, { deleteChildren: deleteChildren })
    // })

    registerUpdateListener('#remove-cards', 'deleteChildren')
    registerUpdateListener('#mark-as-complete-on-done', 'completeOnDone')
    registerUpdateListener('#remove-members-on-done', 'removeMembersOnDone')

    enableAutoMoveConfig(hasFeature('auto_move_cards'))

    sldr.show()
    sldr.on('setPosition', function () { t.sizeTo('#content') })

    $('body').on('lcs-statuschange', '#contact-consent', () => {
      const consent = $('#contact-consent').is(':checked')
      if (consent !== localConsent) {
        consentUpdated(consent)
      }
    })

    if (t.arg('command') === 'show-settings') {
      $('.js-thanks-btn').hide()
    } else {
      $('.js-thanks-btn').on('click', function () {
        skipSettings = true
        const idx = $('#page-authorization').parents('.slick-slide').attr('data-slick-index') || 5
        sldr.slick('slickGoTo', idx)
      })
    }

    $('.js-next-btn').on('click', function () { sldr.slick('slickNext') })
    $('.js-auth-btn').on('click', authorize)
    $('.js-authnext-btn').on('click', authNext)
    $('.js-finish-btn').on('click', function () { t.closeModal() })

    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        if (localConsent === undefined) {
          fbGetConsent(t).then(consent => {
            localConsent = consent
            switchCheckbox('#contact-consent', consent)
          })
        } else {
          fbSetConsent(t, localConsent)
        }
      }
    })

    reportWizardProgress(0)
    sldr.on('afterChange', (e, slick, currentSlide) => reportWizardProgress(currentSlide))

    return Promise.all([updateSelectOptions(), updateAuthElements()])
      .tap(updateOptionsFromConfig)
      .tap(function () {
        t.sizeTo('#content')
      }).catch(x => console.info('###', x))
      .finally(() => onUpdate(() => enableAutoMoveConfig(hasFeature('auto_move_cards'))))
  })
})

function reportWizardProgress (slideNo) {
  const el = $('#slider .slick-slide:nth-child(' + (slideNo + 1) + ') div[data-wiz-id]')
  if (el.length) {
    const id = el.attr('data-wiz-id')
    Metrics.setWizardProgress(id)
  }
}

function registerUpdateListener (id, configField) {
  $('body').on('lcs-statuschange', id, () => {
    const conf = {}
    const checked = $(id).is(':checked')
    conf[configField] = checked
    setConfig(t, conf)
    // if (hasFeature('auto_move_cards') && id === '#auto-move-cards') {
    if (id === '#auto-move-cards') {
      $('#auto-move-scope').prop('disabled', checked ? false : 'disabled')
      $('#backlog-list-selector').prop('disabled', checked ? false : 'disabled')
    }
  })
}

function authorize () {
  return t.getRestApi()
    .authorize({ scope: 'read,write,account' })
    // .tap(e => console.log('auth:', e))
    .tap(updateAuthElements)
    // .tap(updateOptionsFromConfig)
    .tap(authNext)
    .catch(window.TrelloPowerUp.restApiError.AuthDeniedError, function () {
      // Authorization denied, do nothing
    })
}

function updateSelectOptions () {
  return t.lists('id', 'name').then(function (lists) {
    const targetElements = [['list', 1], ['open-list', 0], ['started-list', 1], ['done-list', 0], ['backlog-list', 0]]
    targetElements.forEach(([elName, removeIdx]) => {
      const listSel = $(`#${elName}-selector`)
      listSel.find(`option:gt(${removeIdx})`).remove()
      lists.forEach(list => {
        listSel.append($('<option></option>').attr('value', list.id).text(`list '${list.name}'`))
      })
      listSel.prop('selectedIndex', 0)
    })
  })
}

function updateOptionsFromConfig () {
  // const p1 = getConsent(t).then(function (consent) {
  //   switchCheckbox('#contact-consent', consent)
  // })

  return getConfig(t).then(function (conf) {
    var selectors = [
      ['#list-selector', 'targetId'],
      ['#open-list-selector', 'openListId'],
      ['#started-list-selector', 'startedListId'],
      ['#done-list-selector', 'doneListId'],
      ['#position-selector', 'position']
      // ['#board-selector', 'templateBoard']
    ]

    switchCheckbox('#auto-move-cards', conf.autoMoveCards)
    $('#auto-move-scope').prop('disabled', conf.autoMoveCards ? false : 'disabled')
    $('#backlog-list-selector').prop('disabled', conf.autoMoveCards ? false : 'disabled')
    selectors.push(['#auto-move-scope', 'autoMoveScope'])
    selectors.push(['#backlog-list-selector', 'onHoldListId'])

    switchCheckbox('#remove-cards', conf.deleteChildren)
    switchCheckbox('#mark-as-complete-on-done', conf.completeOnDone)
    switchCheckbox('#remove-members-on-done', conf.removeMembersOnDone)

    selectors.forEach(function (i) {
      const confValue = conf[i[1]]
      if (confValue) {
        $(`${i[0]} option[value="${confValue}"]`).prop('selected', true)
      }
    })

    // Check if it is on-enable trigger and already initialized
    const memberIsReadOnly = !t.memberCanWriteToModel('board')
    settingsDisabled = memberIsReadOnly || (conf.initialized && t.arg('command') !== 'show-settings')
    if (settingsDisabled) {
      const title = memberIsReadOnly
        ? "You need write access to this board in order to change settings. But be sure to authorize the Power-Up on the 'Allow Access' page of this wizard."
        : "This Power-Up has already been configured by another user. To unlock settings, come back to this wizard later via the Power-Up's 'Settings' menu."
      $('.js-settings-enabled-note').hide()
      $(memberIsReadOnly ? '.js-authorization-enabled-note' : '.js-settings-disabled-note').show()
      if (memberIsReadOnly) {
        $('.js-hide-on-readonly').hide()
      }
      $('.js-settings-disable').prop('disabled', 'disabled')
      $('.icon-lock').show().prop('title', title)
      disableCheckbox('#remove-cards', true)

      // if (hasFeature('auto_move_cards')) {
      disableCheckbox('#auto-move-cards', true)
      // }
    } else {
      $('.icon-lock:not(#board-selector-lock)').hide()
      return setConfig(t, { initialized: true })
    }
  })

  // return Promise.all([p1, p2])
}

function updateAuthElements () {
  return t.getRestApi().getToken().then(function (token) {
    // console.log('t:', token)
    if (token) {
      // Power-Up is authenticated
      $('.js-auth-success').show()
      $('.js-auth-btn').hide()
      if (t.getContext().organization) {
        // It's an organization board
        if (t.memberCanWriteToModel('organization')) {
          // User is member of organization
          if (!settingsDisabled) {
            $('#board-selector-lock').hide()
          }
          return updateTemplateBoardOptions(token)
        } else {
          // User is no member of organization
          if (!settingsDisabled) {
            $('#board-selector option:gt(0)').remove()
            $('#board-selector option[value="-"]').text('inaccessible')
            $('#board-selector').prop('disabled', 'disabled')
            $('#board-selector-lock').prop('title', 'The template board setting can only be viewed and changed by team members.')
          }
        }
      } else {
        // It's a private board
        if (!settingsDisabled) {
          $('#board-selector option:gt(0)').remove()
          $('#board-selector').prop('disabled', 'disabled')
          $('#board-selector-lock').prop('title', 'Templates are not available on private boards. Please add the board to a team and then come back to this wizard.')
        }
      }
    } else {
      // Power-Up is not authenticated
      $('.js-auth-success').hide()
      $('.js-auth-btn').show()
      $('#board-selector').prop('disabled', 'disabled')
    }
  })
}

function updateTemplateBoardOptions (token) {
  const p1 = $.get('https://api.trello.com/1/organizations/' + t.getContext().organization + '/boards?fields=id,name&key=' + API_KEY + '&token=' + token)
  return Promise.all([p1, getConfig(t)])
    .spread(function (boards, conf) {
      const boardSel = $('#board-selector')
      $('#board-selector option:gt(0)').remove()
      boards.forEach(board => {
        boardSel.append($('<option></option>').attr('value', board.id).text(board.name))
      })
      if (conf.templateBoard) {
        $(`#board-selector option[value="${conf.templateBoard}"]`).prop('selected', true)
      } else {
        boardSel.prop('selectedIndex', 0)
      }
      boardSel.prop('disabled', settingsDisabled ? 'disabled' : false)
    })
}

function authNext () {
  if (skipSettings) {
    $('#slider').slick('slickGoTo', 8)
  }
}

function switchCheckbox (sel, on) {
  if (on !== undefined) {
    return on ? $(sel).lcs_on() : $(sel).lcs_off()
  }
}

function consentUpdated (consent) {
  localConsent = consent
  if (firebase.auth().currentUser) {
    fbSetConsent(t, consent)
  }
}

function disableCheckbox (sel, disable) {
  $(sel).lcs_disable(disable)
}

/**
 * Feature-flagged auto move cards
 */

var autoMoveCardsEnabled = false

function enableAutoMoveConfig (enabled) {
  if (enabled !== autoMoveCardsEnabled) {
    autoMoveCardsEnabled = enabled
    const sldr = $('#slider')

    if (enabled) {
      sldr.slick('slickAdd', $('<div>').append($('#page-auto-move')).get(), 5, true)
      t.sizeTo('#content')
      $('#auto-move-scope').on('change', evt => setConfig(t, { autoMoveScope: evt.target.value }))
      $('#backlog-list-selector').on('change', evt => setConfig(t, { onHoldListId: evt.target.value }))
      registerUpdateListener('#auto-move-cards', 'autoMoveCards')
      return updateOptionsFromConfig()
    } else {
      $('#auto-move-scope').off('change')
      $('#backlog-list-selector').off('change')
      $('body').off('lcs-statuschange', '#auto-move-cards')
      $('#page-auto-move').appendTo('#slide-cache')
      sldr.slick('slickRemove', 5)
    }
  }
}
